import axiosAPI from 'axios';

const axios = axiosAPI.create({
  // baseURL: 'https://devapi.99gift.ae/gift/',
  baseURL: 'https://api.99gift.ae/gift/',
  // baseURL: process.env.REACT_APP_99GIFT_ENDPOINT,
});

export { axios };
